import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobexdComponent } from './simple-icons-adobexd.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobexdComponent ],
    exports:      [ SimpleIconsAdobexdComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobexdModule {}
